module.exports = __webpack_public_path__ + "../../dist/Messanger/img/conversation.045142c0.svg";